<script>
  import Portal from '../portal/Portal.svelte';

  export let modalTitle = '';
  export let modalSubtitle = '';
  export let content = '';
  export let actions = [];
  export let onBackdropClick;
</script>

<style lang="postcss">
  .modal h4 {
    height: auto;
    margin-bottom: var(--ubilabs-modal-title-gap);
    font-size: var(--ubilabs-modal-title-font-size);
  }

  .subtitle {
    margin: 0;
    font-size: var(--ubilabs-modal-subtitle-font-size);
  }

  .content {
    margin: calc(var(--ubilabs-focus-ring-width) * -1);
    padding: var(--ubilabs-focus-ring-width);
    font-size: var(--ubilabs-modal-content-font-size);
  }

  .content:last-child:not(:first-child) {
    padding-bottom: var(--ubilabs-modal-content-actions-gap);
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    height: var(--ubilabs-modal-actions-height);
    margin-top: var(--ubilabs-modal-content-actions-gap);
  }

  .actions > button {
    margin: 0 var(--ubilabs-modal-actions-gap) 0 0;
  }

  .actions > button:last-child {
    margin-right: 0;
  }

  :global(.modal-wrapper) {
    max-width: 60%;
  }
</style>

<Portal {onBackdropClick} class="modal-wrapper">
  <div class="modal">
    <div class="header">
      {#if modalTitle}
        <h4 class="title" id="modal-title">{modalTitle}</h4>{/if}
      {#if modalSubtitle}
        <p class="subtitle">{modalSubtitle}</p>
      {/if}
    </div>
    {#if content}
      <div class="content">
        {content}
      </div>
    {/if}
    {#if actions?.length}
      <div class="actions">
        {#each actions as action}
          <button on:click={action.clickHandler}>{action.label}</button>
        {/each}
      </div>
    {/if}
  </div>
</Portal>
